import { render, staticRenderFns } from "./CitizenDetails.vue?vue&type=template&id=9a2b893e&"
import script from "./CitizenDetails.vue?vue&type=script&lang=js&"
export * from "./CitizenDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports